import axios from "axios";
import {
    CREATE_AWP,
    CREATE_AWP_REQUEST,
    CREATE_AWP_FAIL,
    SUBMIT_AWP,
    SUBMIT_AWP_REQUEST,
    SUBMIT_AWP_FAIL,
    UPDATE_AWP,
    UPDATE_AWP_REQUEST,
    UPDATE_AWP_FAIL,
    SET_AWP_DRAFT,
    SET_AWP_DRAFT_REQUEST,
    SET_AWP_DRAFT_FAIL,
    SET_AWP_SERVICED,
    SET_AWP_SERVICED_REQUEST,
    SET_AWP_SERVICED_FAIL,
    GET_AWP,
    GET_AWP_REQUEST,
    GET_AWP_FAIL,
    GET_AWPS,
    GET_AWPS_REQUEST,
    GET_AWPS_FAIL,
    GET_AWPS_BY_USER,
    GET_AWPS_BY_USER_REQUEST,
    GET_AWPS_BY_USER_FAIL,
    GET_AWPS_BY_LOCATION,
    GET_AWPS_BY_LOCATION_REQUEST,
    GET_AWPS_BY_LOCATION_FAIL,
    DELETE_AWP,
    DELETE_AWP_REQUEST,
    DELETE_AWP_FAIL,

} from "../types/awpTypes"

const token = localStorage.getItem("token:data");
export const createInspection = (awp) => async (dispatch) => {
    
    try {
        dispatch({
            type: CREATE_AWP_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/awp/inspection`, awp, config);
        dispatch({
            type: CREATE_AWP,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: CREATE_AWP_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const submitInspection = (awp) => async (dispatch) => {
    
    try {
        dispatch({
            type: SUBMIT_AWP_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/awp/inspection/submit`, awp, config);
        dispatch({
            type: SUBMIT_AWP,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: SUBMIT_AWP_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}


export const updateInspection = (awp) => async (dispatch) => {
    
    try {
        dispatch({
            type: UPDATE_AWP_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/awp/inspection/${awp.id}`, awp, config);
        dispatch({
            type: UPDATE_AWP,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: UPDATE_AWP_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const setInspectionDraft = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_AWP_DRAFT_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/awp/inspection/draft/${id}`, null, config);
        dispatch({
            type: SET_AWP_DRAFT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_AWP_DRAFT_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}

export const setInspectionServiced = (service) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_AWP_SERVICED_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/awp/inspection/serviced/${service.id}`, service, config);
        dispatch({
            type: SET_AWP_SERVICED,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_AWP_SERVICED_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getInspections = () => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_AWPS_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/awp/inspections`, config);
        dispatch({
            type: GET_AWPS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_AWPS_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
                });
    }
}

export const getInspection = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_AWP_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/awp/inspection/${id}`, config);
        dispatch({
            type: GET_AWP,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_AWP_FAIL,
            payload:
                error.response && error.response.data?.error
                ? error.response.data?.error
                : error.request
                ? error.request.data?.error
                : error.message,
        });
    }
}

export const getInspectionsByUser = () => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_AWPS_BY_USER_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/awp/myinspections/user`, config);
        dispatch({
            type: GET_AWPS_BY_USER,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_AWPS_BY_USER_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getInspectionsByLocation = (id) => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_AWPS_BY_LOCATION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/awp/inspections/location/${id}`, config);
        dispatch({
            type: GET_AWPS_BY_LOCATION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_AWPS_BY_LOCATION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

export const deleteInspection = (id) => async (dispatch) => {
    try {
        dispatch({
            type: DELETE_AWP_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.delete(`/api/v1/awp/inspection/${id}`, config);
        dispatch({
            type: DELETE_AWP,
        });
    } catch (error) {
        dispatch({
            type: DELETE_AWP_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

